<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        {title: this.$t(`menu.${serviceSlug}`), disabled: true},
        {title: this.$t('menu.iframe/logo-library'), disabled: true}
        ]">
        <div slot="breadcrumbAfter" class="d-flex align-items-center">
          <Searchable class="mr-2" :query-search.sync="querySearch"/>
        </div>
    </Breadcrumbs>

    <FadeTransition
      :duration="400"
      mode="out-in">
      <div class="btn btn__floating btn__round__large btn__round__large">
        <va-popover
          :message="$t('iframe.logos-library.create')"
          placement="left"
        >
          <va-button
            @click.prevent="onClickCreateLogo">
            <i class="fa fa-plus"></i>
          </va-button>

        </va-popover>

      </div>
    </FadeTransition>

    <LogoTable
      ref="iframeLogoTable"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      @filters-updated="onFiltersUpdated"
      @logoClicked="onLogoClicked"
    />

    <CreateLogo
      v-if="showCreateLogo"
      @created="onCreated"
      @cancel="onLogoCreateCancel"
    />
  </div>
</template>
<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import Searchable from "@/components/common/Searchable";
import IndexTablesMixin from "@/mixins/IndexTablesMixin";
import {TABLE_IFRAME_LOGO_LIBRARY} from "@/local-storage/LocalStorageKeys";
import FadeTransition from "@/components/common/transitions/FadeTransition";
import LogoTable from "@/components/iframe/logo-library/LogoTable";
import CreateLogo from "@/components/iframe/logo-library/CreateLogo";
export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  components: {CreateLogo, LogoTable, FadeTransition, Searchable, Breadcrumbs},
  mixins: [
    IndexTablesMixin
  ],
  data () {
    return {
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_IFRAME_LOGO_LIBRARY,
      customQueries: null,
      selectedFlow: null,
      showCreateLogo: false,
    }
  },
  methods: {
    onLogoClicked: function(row) {
      this.$router.push( `/${this.iframeService.slug}/${this.iframeService.slug}/logo-library/${row.id}` )
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    onClickCreateLogo: function () {
      this.showCreateLogo = true
    },
    onLogoCreateCancel: function() {
      this.showCreateLogo = false
    },
    onCreated: function() {
      this.showCreateLogo = false
      this.refreshTable()
    },
    refreshTable: function() {
      this.$refs.iframeLogoTable.reload()
    }
  },
  computed: {
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    entities: function () {
      return this.iframeService ? this.iframeService.entities : null
    },
  }
}
</script>
